import React, {useContext, useEffect, useState} from "react";
import "./Top.scss";
import StyleContext from "../../contexts/StyleContext";

const RADIUS = 17;
const CIRC = 2 * Math.PI * RADIUS; // ≈ 106.8

const ChevronUp = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 8L6 4L10 8" />
  </svg>
);

export default function Top() {
  const {isDark} = useContext(StyleContext);
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setVisible(scrollTop > 300);
      setProgress(docHeight > 0 ? Math.min(1, scrollTop / docHeight) : 0);
    };
    window.addEventListener("scroll", onScroll, {passive: true});
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({top: 0, behavior: "smooth"});
  const dashOffset = CIRC * (1 - progress);

  return (
    <button
      className={`top-btn${isDark ? " top-btn--dark" : ""}${
        visible ? " top-btn--visible" : ""
      }`}
      onClick={scrollTop}
      aria-label={`Back to top, ${Math.round(progress * 100)}% scrolled`}
    >
      {/* Progress ring SVG — fills clockwise from 12 o'clock */}
      <svg className="top-ring" viewBox="0 0 44 44" aria-hidden="true">
        <circle cx="22" cy="22" r={RADIUS} className="top-ring__track" />
        <circle
          cx="22"
          cy="22"
          r={RADIUS}
          className="top-ring__arc"
          strokeDasharray={CIRC}
          strokeDashoffset={dashOffset}
        />
      </svg>

      {/* Glass inner disc + icon */}
      <span className="top-btn__disc">
        <ChevronUp />
      </span>
    </button>
  );
}
